type QueryParamValue = string | number | boolean | null | undefined;

function buildUrl(base: string, params: Record<string, QueryParamValue>): string {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;

    searchParams.set(key, String(value));
  }

  const query = searchParams.toString();
  return query ? `${base}?${query}` : base;
}

export default buildUrl;
